import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Grid, MenuItem, Select, TextField } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import LuxonUtils from '@date-io/luxon';
import { dateUtcToS } from '../../../util/dateUtil';
import { MILITARY_BRANCH_OPTIONS } from '../../../constants/general';

const MilitaryPlanV2 = ({ form, setForm, classes, disabled }) => {
  return (
    <>
      <Grid container direction="row" alignItems="center" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>Military Branch</label>
        </Grid>
        <Grid item xs={12} md={3} className={classes.rowSpacer} style={{ marginTop: 16, marginBottom: 16 }}>
          <FormControl fullWidth variant="outlined" size="small">
            <Select
              id="military-branch"
              value={form.militaryBranch || ''}
              onChange={(event) => setForm({ ...form, militaryBranch: event.target.value })}
              disabled={disabled}
              displayEmpty
            >
              <MenuItem value="" disabled>
                <em>Select Military Branch</em>
              </MenuItem>
              {MILITARY_BRANCH_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>Military Branch:</label>
        </Grid>
        <Grid item xs={6} sm={4} className={classes.rowSpacer}>
          {form.militaryBranch || ''}
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.unprintedContent} style={{ marginTop: 10 }}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>ASVAB Score</label>
        </Grid>
        <Grid item xs={12} md={6} className={classes.textRowSpacer}>
          <FormControl>
            <TextField
              id="act"
              size="small"
              hiddenLabel
              placeholder="ASVAB Score"
              variant="outlined"
              value={form.asvabScore || ''}
              onChange={(event) => setForm({ ...form, asvabScore: event.target.value })}
              inputProps={{ maxLength: 50, classes: { input: classes.textField } }}
              disabled={disabled}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>ASVAB Score</label>
        </Grid>
        <Grid item xs={6} sm={4} className={classes.rowSpacer}>
          {form.asvabScore || ''}
        </Grid>
      </Grid>

      <Grid container direction="row" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>MEPS</label>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>MEPS</label>
        </Grid>
      </Grid>

      <Grid container direction="row" className={classes.unprintedContent}>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={12} md={2} className={classes.textRowLabelSpacer}>
          <label>Date</label>
        </Grid>
        <Grid item xs={6} md={3} className={classes.rowSpacer}>
          {!disabled ? (
            <MuiPickersUtilsProvider utils={LuxonUtils}>
              <KeyboardDatePicker
                fullWidth
                autoOk
                variant="inline"
                id="military-date"
                hiddenLabel
                disablePast
                value={form.militaryDate || null}
                onChange={(date) => {
                  setForm({ ...form, militaryDate: date ? date : null });
                }}
                format="MM/dd/yyyy"
                className={classes.datepicker}
                disabled={disabled}
              />
            </MuiPickersUtilsProvider>
          ) : (
            <summary style={{ marginTop: 3 }} className={classes.subtleBold}>
              {dateUtcToS(form.militaryDate || null)}
            </summary>
          )}
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>Date</label>
        </Grid>
        <Grid item xs={6} sm={4} className={classes.rowSpacer}>
          {dateUtcToS(form.militaryDate || null)}
        </Grid>
      </Grid>

      <Grid container direction="row" className={classes.unprintedContent}>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={12} md={2} className={classes.textRowLabelSpacer}>
          <label>Location</label>
        </Grid>
        <Grid item xs={12} md={3} className={classes.textRowSpacer} style={{ marginTop: 10 }}>
          <FormControl>
            <TextField
              id="act"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form.militaryLocation}
              onChange={(event) => setForm({ ...form, militaryLocation: event.target.value })}
              inputProps={{ maxLength: 100, classes: { input: classes.textField } }}
              disabled={disabled}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>Location</label>
        </Grid>
        <Grid item xs={6} sm={4} className={classes.rowSpacer}>
          {form.militaryLocation}
        </Grid>
      </Grid>

      <Grid container direction="row" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>Basic Training</label>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>Basic Training</label>
        </Grid>
      </Grid>

      <Grid container direction="row" className={classes.unprintedContent}>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={12} md={2} className={classes.textRowLabelSpacer}>
          <label>Date</label>
        </Grid>
        <Grid item xs={6} md={3} className={classes.rowSpacer}>
          {!disabled ? (
            <MuiPickersUtilsProvider utils={LuxonUtils}>
              <KeyboardDatePicker
                fullWidth
                autoOk
                variant="inline"
                id="military-basic-training-date"
                hiddenLabel
                disablePast
                value={form.militaryBasicTrainingDate || null}
                onChange={(date) => {
                  setForm({ ...form, militaryBasicTrainingDate: date ? date : null });
                }}
                format="MM/dd/yyyy"
                className={classes.datepicker}
                disabled={disabled}
              />
            </MuiPickersUtilsProvider>
          ) : (
            <summary style={{ marginTop: 3 }} className={classes.subtleBold}>
              {dateUtcToS(form.militaryBasicTrainingDate || null)}
            </summary>
          )}
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>Date</label>
        </Grid>
        <Grid item xs={6} sm={4} className={classes.rowSpacer}>
          {dateUtcToS(form.militaryBasicTrainingDate || null)}
        </Grid>
      </Grid>

      <Grid container direction="row" className={classes.unprintedContent}>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={12} md={2} className={classes.textRowLabelSpacer}>
          <label>Location</label>
        </Grid>
        <Grid item xs={12} md={3} className={classes.textRowSpacer} style={{ marginTop: 10 }}>
          <FormControl>
            <TextField
              id="military-basic-training-location"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form.militaryBasicTrainingLocation}
              onChange={(event) => setForm({ ...form, militaryBasicTrainingLocation: event.target.value })}
              inputProps={{ maxLength: 100, classes: { input: classes.textField } }}
              disabled={disabled}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>Location</label>
        </Grid>
        <Grid item xs={6} sm={4} className={classes.rowSpacer}>
          {form.militaryBasicTrainingLocation}
        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>Next steps to complete my plan include</label>
        </Grid>
        <Grid item xs={12} md={6} className={classes.rowSpacer} style={{ marginTop: 16, marginBottom: 16 }}>
          <FormControl fullWidth>
            <TextField
              id="act"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form.militaryNextOption}
              onChange={(event) => setForm({ ...form, militaryNextOption: event.target.value })}
              inputProps={{ maxLength: 100, classes: { input: classes.textField } }}
              disabled={disabled}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>Next steps to complete my plan include</label>
        </Grid>
        <Grid item xs={6} sm={4} className={classes.rowSpacer}>
          {form.militaryNextOption}
        </Grid>
      </Grid>
    </>
  );
};

MilitaryPlanV2.propTypes = {
  form: PropTypes.object.isRequired,
  setForm: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default MilitaryPlanV2;
